import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-layout',
    templateUrl: './app-layout.component.html',
    styleUrls: ['./app-layout.component.scss'],
    standalone: false
})
export class AppLayoutComponent implements OnInit {
  public envType = environment.key;
  public showEnvWarning: boolean = false;

  constructor() { }

  ngOnInit(): void {
    this.showEnvWarning = this.envType == 'stage' || this.envType == 'dev';
  }

}
